import * as React from 'react';
import { SVGProps } from 'react';

const SvgLaboratoryResultsOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <g clipPath="url(#a)">
      <path
        d="m12.5 7 3.966 5.603c.368.63.553 1.352.532 2.082a4.293 4.293 0 0 1-.57 2C15.612 18.112 14.107 19 12.5 19c-1.606 0-3.109-.886-3.923-2.31a4.31 4.31 0 0 1-.575-2.007c-.02-.654.124-1.3.415-1.882l.117-.214L12.5 7Zm2.848 7a.652.652 0 0 0-.652.652 2.048 2.048 0 0 1-2.045 2.045.652.652 0 0 0 0 1.303A3.352 3.352 0 0 0 16 14.652a.652.652 0 0 0-.652-.652Zm.302-8 3.836 4.857c.588.919.675 1.98.244 2.992-.406.94-1.189 1.708-2.192 2.151a4.333 4.333 0 0 0-.44-3.994L14 8.083 15.65 6Zm-6.3 0L11 8.083l-3.098 3.923A4.332 4.332 0 0 0 7.462 16c-1.004-.443-1.786-1.21-2.192-2.151-.43-1.011-.344-2.073.244-2.992L9.35 6Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgLaboratoryResultsOutlined;
